import BaseEcharts from './echart.vue'

export default BaseEcharts
